module.exports = __webpack_public_path__ + "static/media/expense-grey.cc2cc626.svg";